import * as React from "react"
import {useEffect} from "react"
import {number, object} from "yup";
import {AutocompleteAjaxSeeker} from "@ui-seeker/core";
import {useValidatorSeeker} from "@ui-seeker/app";

import {BACKEND_APIS} from "@constants";
import {useMatchersSkusForm} from "../../@hooks";
import {matcherSKUDrawerError} from "../../@signals";


export default function MatchersSKUsDrawerCompany() {
	const { localValue, handleChange } = useMatchersSkusForm('companyID')
	const { errors } = useValidatorSeeker({
		companyID: localValue === 'null' ? 0 : (localValue || null)
	}, object({
		companyID: number().required('Company is mandatory')
	}))

	useEffect(() => {
		matcherSKUDrawerError.value = {
			...matcherSKUDrawerError.value,
			companyID: errors?.companyID
		}
	}, [errors?.companyID]);

    return <AutocompleteAjaxSeeker
		urlAjax={`${BACKEND_APIS.BRANDS}/crud/company`}
        label="Company"
        placeholder="Please select a company"
		value={localValue || ''}
		onChange={newValue => handleChange(newValue.target.value)}
		error={errors?.companyID}
	/>
}
